import { UUID } from 'crypto';
import { CargoContent } from '../Stowage/Manifest/CargoContent';
import { StowagePlanChange } from '../Stowage/StowagePlanChange';
import { Violation } from '../Stowage/Violation/Violation';
import { Tank } from './Tank';
import { RotationBerthCall } from '../Stowage/Rotation/RotationBerthCall';

export interface DeckTank {
    tank: Tank;
    xOffset: number;
    width: number;
}

export interface TankRow {
    tanks: Tank[];
}

export interface TankColumn {
    tankRows: TankRow[];
    startFrame: number;
    endFrame: number;
    flexWidth: number;
}

export interface TankPlan {
    deckTanks: DeckTank[];
    tankColumns: TankColumn[];
    shipMaxRows: number;
}

export enum TankSectionEnum {
    Center = 1,
    Deck = 2,
    Wing = 3,
}

export enum TankSideEnum {
    Port = 1,
    Center = 2,
    Starboard = 3,
}

export interface ContextMenuState {
    visible: boolean;
    tank: Tank | null;
    cargoContents: CargoContent[];
    cargoOperationGuid: UUID;
    berthCall: RotationBerthCall | null;
    x: number;
    y: number;
    violations: Violation[] | null;
}

export enum OverlayMenuEnum {
    TankDetails = 1,
    CargoDetails = 2,
    EditStowage = 3,
    EditShipFigure = 4,
    BlockTank = 5,
    PreviousCargoes = 6,
}

export interface OverlayMenuState {
    visible: boolean;
    type: OverlayMenuEnum;
    tank: Tank | null;
    cargoContents: CargoContent[] | null;
    stowagePlanChanges?: StowagePlanChange[];
}
